export const dnldSavedApis = (builder) => ({
    dnldSavedApis: builder.mutation({
    query: ({search, sortBy, sortOrder, startDate, endDate, loggedin_user_id, user_type_id,}) => {
      return {
        url: "/download_api_integrations",
        method: "GET",
        params: { search, sortBy, sortOrder, startDate, endDate, loggedin_user_id, user_type_id, },
        headers: {
          "Content-Type": "text/csv",
        },
        responseHandler: (response) => response.blob(),
      };
    },
  }),
});
